module.exports = __webpack_public_path__ + "img/map.1edffd0b.png";